import { getBanners } from '~/src/api/content/banners';
import { TAppThunkDispatch, TGetState } from '~/src/store';

import { ESubscriptionsDomruTvActions } from '../reducers';

export const fetchBanners = () => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState) => {
        const { city: { provider: { providerId } }, auth: { isAuth }  } = getState();
        const banners = await getBanners({
            providerId,
            isAuth,
            tag: 'movix',
            expand: 'bannerInfo.advertising,bannerInfo.tags,order',
        });

        dispatch({
            type: ESubscriptionsDomruTvActions.FETCH_BANNERS,
            payload: {
                banners: banners,
            },
        });
    };
};
